import React from 'react';

import { FormattedMessageWrapper } from '@goeuro/app/client/fe-utils/src/localization/FormattedMessageStopgap/FormattedMessageWrapper';
import useWhitelabel from '@goeuro/app/client/b2b-components/src/hooks/use-whitelabel';
import SmartFooter from '@goeuro/app/client/b2b-components/src/components/smart-footer/SmartFooter';
import { useGlobalState } from 'hooks';
import { prepareLinkTo } from 'shared/utils/url';
import { SectionFlattenProps } from '../section/Section.props';
import * as Styled from './Footer.styled';

const Footer = ({ theme }: SectionFlattenProps) => {
  const { locale } = useGlobalState();
  const { wlData } = useWhitelabel();
  const color = theme?.color || '';
  const helpCentreUrl =
    wlData?.partnerId === 'raileuropewl'
      ? 'https://help.raileurope.com/'
      : prepareLinkTo('/app/support', locale);

  const renderFooter = () => (
    /* @ts-ignore */
    <SmartFooter>
      <Styled.Links>
        <Styled.NormalLink color={color} href={helpCentreUrl}>
          <FormattedMessageWrapper translationId="lps.footer.helpCentre" />
        </Styled.NormalLink>
        <Styled.Link color={color} to={prepareLinkTo('/legal', locale)}>
          <FormattedMessageWrapper translationId="FOOTER.IMPRINT" />
        </Styled.Link>
        <Styled.Link color={color} to={prepareLinkTo('/terms-of-use', locale)}>
          <FormattedMessageWrapper translationId="FOOTER.TERMS" />
        </Styled.Link>
        <Styled.Link
          color={color}
          to={prepareLinkTo('/privacy-policy', locale)}
        >
          <FormattedMessageWrapper translationId="FOOTER.PRIVACY" />
        </Styled.Link>
      </Styled.Links>
    </SmartFooter>
  );

  if (wlData?.customFooter) return renderFooter();

  return (
    <Styled.Footer>
      <Styled.Container>{renderFooter()}</Styled.Container>
    </Styled.Footer>
  );
};

export default Footer;
